<template>
<v-container class="general-resource-details py-lg-8 py-4">
  <h1 style="color: black !important;" class="text-center pb-2">{{title}}</h1>
  <v-data-iterator class="py-2" :items="ResourceCards.items" :items-per-page.sync="ResourceCards.itemsPerPage" hide-default-footer>
    <template v-slot:default="props">
      <v-row>
        <v-col v-for="item in props.items" :key="item.name" cols="12" sm="6" md="4" lg="3">
          <v-card :color="item.color" elevation="4" dark>
            <v-card-title class="subheading font-weight-bold">
              {{ item.title }}
            </v-card-title>

            <v-divider></v-divider>

            <v-list class="white" v-for="resource in item.resources" :key="resource.name" dense>
              <v-list-item>
                <a style="text-decoration: none; color: inherit;" :href="resource.url" target="_blank">
                  <v-list-item-content class="black--text">
                    <p>{{resource.name}}
                      <v-icon color="black">{{resource.icon}}</v-icon>
                    </p>
                  </v-list-item-content>
                </a>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-data-iterator>
</v-container>
</template>

<script>
import ResourceCards from '@/copy/ResourceCards';

export default {
  name: 'ResourceDetails',
  data() {
    return {
      title: 'Free Resources',
      ResourceCards,
    }
  }
};
</script>
